import { z } from "zod";

export type CategoricalBreakdownConfig = {
  type: "categorical";
  key: string;
  name: string;
  choices: { label: string; value: string }[];
  default?: boolean;
};

export type MonthRangeBreakdownConfig = {
  type: "month";
  key: string;
  name: string;
  minMonth: string;
  maxMonth: string;
};

export type BreakdownConfig =
  | CategoricalBreakdownConfig
  | MonthRangeBreakdownConfig;

export const BreakdownSchema = z.object({
  key: z.string(),
  values: z.array(z.string()),
  groupUnselectedIntoOther: z.boolean().optional(),
});

export type Breakdown = z.infer<typeof BreakdownSchema>;

export const isBreakdown = (value: unknown): value is Breakdown => {
  const parsed = BreakdownSchema.safeParse(value);
  return parsed.success;
};

export const isBreakdownList = (value: unknown): value is Breakdown[] => {
  const schema = z.array(BreakdownSchema);
  return schema.safeParse(value).success;
};

export const parseBreakdownListQueryParam = (
  arg: string | null,
): Breakdown[] | null => {
  if (arg === null) {
    return null;
  }
  let value: unknown;
  try {
    value = JSON.parse(arg);
  } catch (e) {
    return null;
  }
  return isBreakdownList(value) ? value : null;
};

export const parseBreakdownQueryParam = (
  arg: string | null,
): Breakdown | null => {
  if (!arg) {
    return null;
  }
  let value: unknown;
  try {
    value = JSON.parse(arg);
  } catch (e) {
    return null;
  }
  return isBreakdown(value) ? value : null;
};
